export default __webpack_public_path__ + "static/media/zlota.1d0cf2ae.png";